<template>
	<div id="index">
		<Header></Header>
		<Search></Search>
		<Nav></Nav>
		<div class="content">
			<div class="w index-content">
				<template v-if="template_list.length">
					<template v-for="(item,index) in template_list">
						<banner :param="item.param" v-if="item.type == 'banner'"></banner>
						<!-- 商品广告位 -->
						<adsense :param="item.param" v-if="item.type == 'adsense'"></adsense>
						<miaosha :param="item.param" v-if="item.type == 'miaosha'"></miaosha>
						<!-- 特价商品 -->
						<special :param='item.param' v-if="item.type == 'special'"></special>
						<!-- 排行榜 -->
						<goodsRanking :param='item.param' v-if="item.type == 'goodsRanking'"></goodsRanking>
						<!-- 新品 -->
						<news :param='item.param' v-if="item.type == 'new'"></news>
						<!-- 品牌推荐 -->
						<brand :param='item.param' v-if="item.type == 'brand'"></brand>
						<!-- 热销商品 -->
						<hot :param='item.param' v-if="item.type == 'hot'"></hot>
						<!-- 好物推荐 -->
						<fine :param='item.param' v-if="item.type == 'fine'"></fine>
						<!-- 特色推荐1 -->
						<feature1 :param='item.param' v-if="item.type == 'feature1'"></feature1>
						<!-- 特色推荐2 -->
						<feature2 :param='item.param' v-if="item.type == 'feature2'"></feature2>
						<!-- 实力商家 -->
						<store :param='item.param' v-if="item.type == 'storeRanking'"></store>
						<!-- 频道广场 -->
						<channel :param='item.param' v-if="item.type == 'channel'"></channel>
						<!-- 猜你喜欢 -->
						<like :param='item.param' v-if="item.type == 'like'"></like>
						<!-- 楼层 -->
						<floor :param='item.param' v-if="item.type == 'floor'" :id="index"></floor>
						<!-- 广告位 -->
						<seat :param='item.param' :index="index" v-if="item.type == 'seat'"></seat>
					</template>
				</template>
				<div class="floor">
					<template v-for="(item,index) in template_list">
						<template v-if="item.type == 'floor'">
							<div class="floor-item" :class="{'active':floor_active == index}" @click="floorClick(index)" v-text="item.param.floor_title || item.param.title"></div>
						</template>
					</template>
				</div>
				<div class="back-top" :class="{'active' : scroll_top}" @click="backTop">Top</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	let timeFun = null;
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";
	import banner from "./components/banner";
	import adsense from "./components/adsense";
	import miaosha from "./components/seckill"; //秒杀
	import special from "./components/special";
	import goodsRanking from "./components/goodsRanking";
	import news from "./components/new";
	import brand from "./components/brand";
	import hot from "./components/hot";
	import feature1 from "./components/feature1";
	import feature2 from "./components/feature2";
	import fine from "./components/fine";
	import channel from "./components/channel";
	import like from "./components/like";
	import store from "./components/store";
	import floor from "./components/floor";
	import seat from "./components/seat";

	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
			banner,
			miaosha,
			adsense,
			special,
			goodsRanking,
			news,
			brand,
			hot,
			feature1,
			feature2,
			fine,
			channel,
			like,
			store,
			floor,
			seat
		},
		data() {
			return {
				template_list: [], //diy返回模块
				scroll_top: false,
				floor_active: -1,
                page_id:'',
			};
		},
		created() {
            if(this.$route.query.page_id){
                this.page_id=this.$route.query.page_id
            }
			this.getData();
		},
		mounted() {
			let that = this;
			window.onscroll = function() {
				let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
				if(scroll_top >= 400){
					that.scroll_top = true;
				}else{
					that.scroll_top = false;
				}
				let floot_list = document.getElementsByClassName("floor-box");
				for (let i = 0; i < floot_list.length; i++) {
					if(scroll_top >= floot_list[i].offsetTop+165){
						that.floor_active = floot_list[i].parentNode.id;
					}
				}
			}
		},
		methods: {
			getData() {
                let params={
                    page_id:this.page_id
                }
				this.$loading();
				this.$api.stencilindex(params).then((res) => {
					if (res.code == 0) {
						this.$loading().close();
						this.template_list = res.data.template;
					}
				})
				.catch((err) => {
					this.common.message(this, err);
				});
			},
			backTop() {
				this.common.backTop(20);
			},
			floorClick(id) {
				document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
				/* clearInterval(timeFun)
				timeFun = setInterval(()=> {
					let offset_top = document.getElementById(id).offsetTop+186;
					let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
					if(offset_top>scroll_top){
						document.documentElement.scrollTop = document.body.scrollTop = scroll_top+(offset_top/100);
						if (scroll_top >= offset_top) {
							document.documentElement.scrollTop = document.body.scrollTop = offset_top;
							clearInterval(timeFun);
						}
					}else{
						document.documentElement.scrollTop = document.body.scrollTop = scroll_top-(offset_top/100);
						if (scroll_top <= offset_top) {
							document.documentElement.scrollTop = document.body.scrollTop = offset_top;
							clearInterval(timeFun);
						}
					}
				}, 5) */
			}
		}
	};
</script>

<style lang="scss" scoped>
	.w {
		position: relative;
	}

	.content {
		width: 100%;
		height: 100%;
		background-color: #f2f2f2;
		padding-bottom: 60px;
		box-sizing: border-box;

		.index-content {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
		}
	}

	.back-top {
		cursor: pointer;
		font-size: 14px;
		position: fixed;
		text-align: center;
		z-index: 9999;
		visibility: hidden;
		opacity: 0;
		transition: 1s;
		background: #121212;
		color: #ffffff;
		border-radius: 3px;
		padding: 12px;
		right: 20px;
		bottom: 45px;
	}
	.back-top.active{
		visibility: visible;
		opacity: 1;
		transition: 0.3s;
	}
	.floor {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateY(-50%);
		margin-left: 620px;
		width: 50px;
		background: #fff;
		padding: 0 11px;
		box-sizing: border-box;
		border-radius: 8px;
		z-index: 100;

		.floor-item {
			cursor: pointer;
			padding: 10px 0;
			box-sizing: border-box;
			width: 28px;
			// height: 40px;
			font-size: 14px;
			line-height: 20px;

			+.floor-item {
				border-top: 1px solid #ebebeb;
			}

			&:hover {
				color: #ff0e25;
			}
		}
		.floor-item.active{
			color: #ff0e25;
		}
	}
</style>
